import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27f183be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_task" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "问题类型：", -1))
const _hoisted_7 = { class: "header_nr flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "反馈人：", -1))
const _hoisted_9 = { class: "header_nr flexAlign" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "订单号：", -1))
const _hoisted_11 = { class: "header_nr flexAlign" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "问题分类：", -1))
const _hoisted_13 = { class: "header_nr flexAlign" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "客户收费金额：", -1))
const _hoisted_15 = { class: "header_nr flexAlign" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "收款确认姓名：", -1))
const _hoisted_17 = { class: "header_nr flexAlign" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "付款确认姓名：", -1))
const _hoisted_19 = {
  class: "header_nr flexAlign",
  style: {"margin-left":"20px"}
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Excel导入")
const _hoisted_24 = {
  href: "/pages/template/售后导入文件.xlsx",
  target: "_blank",
  style: {"margin-left":"10px"}
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode("下载模板")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("综合导入")
const _hoisted_28 = {
  href: "/pages/template/综合导入文件.xlsx",
  target: "_blank",
  style: {"margin-left":"10px"}
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode("综合导入模板下载")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("移除")
const _hoisted_33 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_34 = { class: "my-header" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "详情", -1))

import { useRouter,useRoute } from 'vue-router';
	import { onMounted,ref,nextTick,computed } from 'vue';
	import { apiName,reqPostsaleanalysisList,reqPostsaleanalysisDelete,reqPostsaleanalysisImport,reqPostsaleanalysisImportAll } from '@/api/api';
	import { requestProjectAllList,requestAllTaskList } from '@/api/xmApi';
	import EditConfig from '@/views/SH/EditPostsaleanalysislist.vue';
	import { ElMessage } from 'element-plus';
	
	
export default /*#__PURE__*/_defineComponent({
  name: 'postsaleanalysislist',
  setup(__props) {

	const editid = ref<string>("")//打开编辑传uuid
	const api = ref<string>(apiName)
	const router = useRouter()
	const route = useRoute()
	const list = ref([])
	const loading = ref<boolean>(false)
	const addShowTask = ref<boolean>(false)//添加任务
	const addTask = ref<boolean>(false)
	const taskDetails = ref(false)//控制右侧弹窗
	const taskDetailsShow = ref(false)//控制右侧弹窗
	const form = ref({})
	const sxlxLists = ref<any[]>([])
	const projectlist = ref([])
	const taskid = ref(route.params.taskid)
	const yuqi =ref(route.params.yuqi);
	const pageIndex = ref<number>(1)
	const pageSize = ref<number>(10)
	const pages = ref({
		totalCount:0
	})

	const delconfig = (row:any) =>{
		reqPostsaleanalysisDelete({
			id:row.cell.id
		}).then((res:any)=>{
			if(res.status === 1){
			    ElMessage({
			        message: "移除成功",
			        type: 'success',
			        duration: 500
			    });
				setTimeout(()=>{
					pageIndex.value = 1
					ConfigList3()
				},500)
			}
		})
	}
	
	const addShowConfig = ref<boolean>(false)//添加编辑项目
	const ConfigShow = ref<boolean>(false)//添加任务
	const detailsconfig = (row: any) =>{
		editid.value = row
		sx();
		addShowConfig.value = true
	}
	const sx = () =>{
		ConfigShow.value = false
		nextTick(()=>{
			ConfigShow.value = true
		})
	}

	const getallprojectList = () => {
		requestProjectAllList({}).then((res:any)=>{
			projectlist.value=res.datalist;
		})
	}
	const search = ref({
		wtlx:"",
		fkr:"",
		ddh:"",
		wtfl:"",
		khsfje0:"",
		skqrxm:"",
		fkqrxm:""
	})
	
	const cancelDetails = () => {
		taskDetails.value = false
		ConfigList3()
	}
	const cancelShowConfig = (val:any) =>{
		addShowConfig.value = false
		if(val){
			ConfigList3()
		}
	}
	const searchList = () =>{
		pageIndex.value = 1
		ConfigList3();
	}
	const details = (row:any) => {
		form.value = row.cell
		taskDetailsShow.value = false
		nextTick(()=>{
			taskDetailsShow.value = true
		})
		taskDetails.value = true
	}
	//刷新列表
	const taskListsx = () => {
		ConfigList3()
		taskDetails.value = false
	}
	//新建任务
	const createTask = () => {
		tasksx()
		addShowTask.value = true
	}
	const tasksx = () => {
		addTask.value = false
		nextTick(()=>{
			addTask.value = true
		})
	}
	onMounted(()=>{
		ConfigList3();
	})
	
	const ConfigList3 = () => {
		loading.value = true
		reqPostsaleanalysisList({
			pageIndex:pageIndex.value,
			pageSize:pageSize.value,
			wtlx:search.value.wtlx,
			fkr:search.value.fkr,
			ddh:search.value.ddh,
			wtfl:search.value.wtfl,
			khsfje0:search.value.khsfje0,
			skqrxm:search.value.skqrxm,
			fkqrxm:search.value.fkqrxm,
		}).then((res:any)=>{
			list.value = res.data
			pages.value.totalCount = res.totalCount
			loading.value = false
		})
	}
	const handleSizeChange = (val: number) =>{
		pageSize.value = val
		ConfigList3();
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		ConfigList3();
	}
	const importing = ref<boolean>(false)
	const beforeUpload = (file:any) => {
		const isExcel = file.name.endsWith('.xlsx') || file.name.endsWith('.xls')
		if (!isExcel) {
			ElMessage.error('只能上传Excel文件(.xlsx/.xls)')
			return false
		}
		importing.value = true
		return true
	}
	const onUploadSuccess = (res:any) => {
		if(res.errno === 0 ){
			// 文件上传成功，调用导入接口
			reqPostsaleanalysisImport({
				filepath: res.data[0].href
			}).then((importRes:any)=>{
				importing.value = false
				if(importRes.status === 1){
					ElMessage({message: importRes.msg, type: 'success', duration: 1500})
					setTimeout(()=>{
						pageIndex.value = 1
						ConfigList3()
					},500)
				} else {
					ElMessage({message: importRes.msg || '导入失败', type: 'error', duration: 2000})
				}
			})
		} else {
			importing.value = false
			ElMessage({message: res.msg || '文件上传失败', type: 'error', duration: 1500})
		}
	}
	// 综合导入：一份Excel同时导入售后分析表 + 数据收集模板「计划动态表」
	const onUploadSuccessAll = (res:any) => {
		if(res.errno === 0 ){
			reqPostsaleanalysisImportAll({
				filepath: res.data[0].href
			}).then((importRes:any)=>{
				importing.value = false
				if(importRes.status === 1){
					ElMessage({message: importRes.msg, type: 'success', duration: 2000})
					setTimeout(()=>{
						pageIndex.value = 1
						ConfigList3()
					},500)
				} else {
					ElMessage({message: importRes.msg || '综合导入失败', type: 'error', duration: 3000})
				}
			})
		} else {
			importing.value = false
			ElMessage({message: res.msg || '文件上传失败', type: 'error', duration: 1500})
		}
	}
	const back = () =>{
		router.go(-1)
	}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.wtlx,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.wtlx) = $event)),
              style: {width:'100px'},
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.fkr,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.value.fkr) = $event)),
              style: {width:'100px'},
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.ddh,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((search.value.ddh) = $event)),
              style: {width:'100px'},
              onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.wtfl,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((search.value.wtfl) = $event)),
              style: {width:'100px'},
              onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_el_select, {
              size: "small",
              modelValue: search.value.khsfje0,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((search.value.khsfje0) = $event)),
              style: {width:'120px'},
              clearable: "",
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "为0",
                  value: "1"
                }),
                _createVNode(_component_el_option, {
                  label: "不为0",
                  value: "2"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_el_select, {
              size: "small",
              modelValue: search.value.skqrxm,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((search.value.skqrxm) = $event)),
              style: {width:'120px'},
              clearable: "",
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "为空",
                  value: "1"
                }),
                _createVNode(_component_el_option, {
                  label: "不为空",
                  value: "2"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_el_select, {
              size: "small",
              modelValue: search.value.fkqrxm,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((search.value.fkqrxm) = $event)),
              style: {width:'120px'},
              clearable: "",
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "为空",
                  value: "1"
                }),
                _createVNode(_component_el_option, {
                  label: "不为空",
                  value: "2"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              size: "small",
              icon: _ctx.Search,
              onClick: _cache[11] || (_cache[11] = ($event: any) => (searchList()))
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (detailsconfig(0)))
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }),
            _hoisted_22,
            _createVNode(_component_el_upload, {
              action: `${api.value}/frame/uploadfile1`,
              "show-file-list": false,
              accept: ".xlsx,.xls",
              "on-success": onUploadSuccess,
              "before-upload": beforeUpload
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "warning",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["action"]),
            _createElementVNode("a", _hoisted_24, [
              _createVNode(_component_el_button, {
                type: "info",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              })
            ]),
            _hoisted_26,
            _createVNode(_component_el_upload, {
              action: `${api.value}/frame/uploadfile1`,
              "show-file-list": false,
              accept: ".xlsx,.xls",
              "on-success": onUploadSuccessAll,
              "before-upload": beforeUpload
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "warning",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_27
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["action"]),
            _createElementVNode("a", _hoisted_28, [
              _createVNode(_component_el_button, {
                type: "info",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _hoisted_29
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _hoisted_30,
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      onCellClick: details,
      data: list.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "80",
          label: "序号",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.fksj",
          label: "反馈时间",
          width: "100",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.fkr",
          label: "反馈人",
          width: "130",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.ddh",
          label: "订单号",
          width: "130",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.wtlx",
          label: "问题类型",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.tzlx",
          label: "涂装类型",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.wtfl",
          label: "问题分类",
          width: "120",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.yysx",
          label: "原因事项",
          width: "250",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.bcjjfa",
          label: "本次解决方案",
          width: "120",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.ytfxdjfa",
          label: "源头分析杜绝方案",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.ytgw",
          label: "源头岗位",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.zrbmr",
          label: "责任部门/人",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.nwb",
          label: "内外部",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.ssjehj",
          label: "损失金额合计",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.clfy",
          label: "差旅费用",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.rggz",
          label: "人工工资",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.clf",
          label: "材料费",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.kdf",
          label: "快递费",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.khsfje",
          label: "客户收费金额",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.skqrsj",
          label: "收款确认时间",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.skqrxm",
          label: "收款确认人姓名",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.fkqrsj",
          label: "付款确认时间",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.fkqrxm",
          label: "付款确认人姓名",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "项目操作",
          width: "150",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "small",
              onClick: _withModifiers(($event: any) => (detailsconfig(scope.row.cell.id)), ["stop"])
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              link: "",
              type: "danger",
              size: "small",
              onClick: _withModifiers(($event: any) => (delconfig(scope.row)), ["stop"])
            }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[14] || (_cache[14] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      top: "5vh",
      modelValue: addShowConfig.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((addShowConfig).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (addShowConfig.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (addShowConfig.value)
          ? (_openBlock(), _createBlock(EditConfig, {
              key: 0,
              editid: editid.value,
              onCancelShowConfig: cancelShowConfig
            }, null, 8, ["editid"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})